import { StripeCountryCode, StripePlatform } from "@modules/payment/stripeTypes"
import { z } from "zod"

export const StripeAvailableCountriesDtoSchema = z
  .object({
    countriesByPlatform: z.record(z.enum(StripePlatform), z.array(z.enum(StripeCountryCode)).optional()),
  })
  .meta({ id: "StripeAvailableCountriesDtoSchema" })

export type StripeAvailableCountriesDto = z.infer<typeof StripeAvailableCountriesDtoSchema>
